<button *ngIf="options().closeButton" (click)="remove()" type="button" class="toast-close-button" aria-label="Close">
    <span aria-hidden="true">&times;</span>
</button>
<div *ngIf="title()" [class]="options().titleClass" [attr.aria-label]="title()">
    {{ title() }}
    <ng-container *ngIf="duplicatesCount">[{{ duplicatesCount + 1 }}]</ng-container>
</div>
<div *ngIf="message() && options().enableHtml" role="alert" [class]="options().messageClass" [innerHTML]="message()"></div>
<div *ngIf="message() && !options().enableHtml" role="alert" [class]="options().messageClass" [attr.aria-label]="message()">
    {{ message() }}
</div>
<a *ngIf="canAskCopilot" class="toast-ask-copilot" data-ai-ignore role="button" (click)="askCopilot($event)">{{ askLabel }}</a>
<button *ngIf="$any(options()).retryButton" (click)="action($event)" type="button" class="toast-close-button" aria-label="Reload">
    <div [class]="options().titleClass">Retry</div>
</button>
<div *ngIf="options().progressBar">
    <div class="toast-progress" [style.width]="width() + '%'"></div>
</div>
